@if (tariff) {
  <div class="total-card">
    <div class="total-card__item">
      <div class="total-card__inner">
        <p>{{ 'TARIFFS.CREDITS' | translate }}</p>
        <p>{{ tariff.contactCredits | numberWithSpaces }}</p>
      </div>
      <div class="total-card__inner">
        <p>{{ 'TARIFFS.EXPORT_CREDITS' | translate }}</p>
        <p>{{ tariff.exportCredits | numberWithSpaces }}</p>
      </div>
    </div>
    <div class="dash-devider">
      <span class="dash-devider__circle left"></span>
      <div class="dash-devider__line"></div>
      <span class="dash-devider__circle right"></span>
    </div>
    <div class="total-card__item">
      <div class="total-card__inner">
        <div class="total-card__text">
          <p>{{ 'TARIFFS.PRICE_FOR_USER' | translate }}</p>
          <p class="faded-text">{{ 'TARIFFS.PRICE_FOR_ONE_MONTH' | translate }}</p>
        </div>
        <p>${{ tariff.monthUserPrice }}</p>
      </div>
      <div class="total-card__inner">
        <div class="total-card__discount">
          <p>{{ 'TARIFFS.DISCOUNT_NAME' | translate }}</p>
          <div class="discount">{{ tariff.usageDiscountPercent | discountDisplay: true }}</div>
        </div>
        <p class="italic-text">{{ tariff.usageDiscount | discountDisplay: false : true }}</p>
      </div>
      <div class="total-card__inner">
        <p>{{ 'TARIFFS.PRICE' | translate }}</p>
        <p>${{ tariff.usageTotalPrice }}</p>
      </div>
    </div>
    <div class="devider"></div>
    <div class="total-card__item">
      <div class="total-card__inner">
        <div class="total-card__text">
          <p>{{ 'TARIFFS.LINKEDIN_SLOTS.TITLE' | translate }}</p>
          <p class="faded-text">{{ 'TARIFFS.LINKEDIN_SLOTS.PRICE_FOR' | translate }}</p>
        </div>
        <p>${{ tariff.pricePerLinkedinSlot }}</p>
      </div>
      <div class="total-card__inner">
        <div class="total-card__discount">
          <p>{{ 'TARIFFS.DISCOUNT_NAME' | translate }}</p>
          <div class="discount">
            {{ tariff.linkedinSlotsDiscountPercent | discountDisplay: true }}
          </div>
        </div>
        <p class="italic-text">
          {{ tariff.linkedinSlotsDiscount | discountDisplay: false : true }}
        </p>
      </div>
      <div class="total-card__inner">
        <p>{{ 'TARIFFS.PRICE' | translate }}</p>
        <p>${{ tariff.linkedinSlotsTotalPrice }}</p>
      </div>
    </div>
    <div class="devider"></div>
    <div class="price-total">
      <p>{{ 'TARIFFS.TOTAL_COST' | translate }}</p>
      <p>${{ tariff.totalPrice }}</p>
    </div>
    <div class="cover"></div>
    <div class="triangle"></div>
  </div>
} @else {
  <div class="total-card">
    <div class="total-card__item">
      <div class="total-card__inner">
        <p>{{ 'TARIFFS.CREDITS' | translate }}</p>
        <div class="main-preview"></div>
      </div>
      <div class="total-card__inner">
        <p>{{ 'TARIFFS.EXPORT_CREDITS' | translate }}</p>
        <div class="main-preview"></div>
      </div>
    </div>
    <div class="dash-devider">
      <span class="dash-devider__circle left"></span>
      <div class="dash-devider__line"></div>
      <span class="dash-devider__circle right"></span>
    </div>
    <div class="total-card__item">
      <div class="total-card__inner">
        <div class="total-card__text">
          <p>{{ 'TARIFFS.PRICE_FOR_USER' | translate }}</p>
          <p class="faded-text">{{ 'TARIFFS.PRICE_FOR_ONE_MONTH' | translate }}</p>
        </div>
        <div class="main-preview"></div>
      </div>
      <div class="total-card__inner">
        <div class="total-card__discount">
          <p>{{ 'TARIFFS.DISCOUNT_NAME' | translate }}</p>
          <div class="discount-preview"></div>
        </div>
        <div class="main-preview"></div>
      </div>
      <div class="total-card__inner">
        <p>{{ 'TARIFFS.PRICE' | translate }}</p>
        <div class="main-preview"></div>
      </div>
    </div>
    <div class="devider"></div>
    <div class="total-card__item">
      <div class="total-card__inner">
        <div class="total-card__text">
          <p>{{ 'TARIFFS.LINKEDIN_SLOTS.TITLE' | translate }}</p>
          <p class="faded-text">{{ 'TARIFFS.LINKEDIN_SLOTS.PRICE_FOR' | translate }}</p>
        </div>
        <div class="main-preview"></div>
      </div>
      <div class="total-card__inner">
        <div class="total-card__discount">
          <p>{{ 'TARIFFS.DISCOUNT_NAME' | translate }}</p>
          <div class="discount-preview"></div>
        </div>
        <div class="main-preview"></div>
      </div>
      <div class="total-card__inner">
        <p>{{ 'TARIFFS.PRICE' | translate }}</p>
        <div class="main-preview"></div>
      </div>
    </div>
    <div class="devider"></div>
    <div class="price-total">
      <p>{{ 'TARIFFS.TOTAL_COST' | translate }}</p>
      <div class="total-preview"></div>
    </div>
    <div class="cover"></div>
    <div class="triangle"></div>
  </div>
}
